<template>
    <span>

        <v-navigation-drawer app
                             v-model="drawermain"
                             color="#FFA500"
                             dark
                             temporary
                             :key="this.$store.state.chipcount"
                             disable-resize-watcher>
            <v-list>
                <v-subheader>OPTIONS</v-subheader>
                <v-list-item-group color="#FFA500">
                    <v-list-item :key="0" :to="'/alerts'" v-on:click.native="setMode('Alerts')">
                        <v-list-item-icon><img src="assets/alert.png" height="20" width="20"></v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title class="boldtext" style="color:black;">ALERTS</v-list-item-title>
                            <div v-if="redalertsexist">{{redcount}}</div>
                            <div v-if="amberalertsexist">{{ambercount}}</div>
                            <div v-if="greenalertsexist">{{greencount}}</div>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item :key="1" :to="'/capture'" disabled v-on:click.native="setMode('Capture')">
                        <v-list-item-icon><v-icon disabled color="black">photo_camera</v-icon></v-list-item-icon>
                        <v-list-item-content><v-list-item-title disabled class="boldtext" style="color:#efd491;">CAPTURE</v-list-item-title></v-list-item-content>
                    </v-list-item>
                    <v-list-item :key="2" :to="'/choosesurvey'" v-on:click.native="setMode('ChooseSurvey')">
                        <v-list-item-icon><v-icon color="black">explore</v-icon></v-list-item-icon>
                        <v-list-item-content><v-list-item-title class="boldtext" style="color:black;">EXPLORE</v-list-item-title></v-list-item-content>
                    </v-list-item>
                    <v-list-item :key="3" v-on:click.native="setMode('ChooseShare')">
                        <v-list-item-icon><v-icon color="black">share</v-icon></v-list-item-icon>
                        <v-list-item-content><v-list-item-title class="boldtext" style="color:black;">SHARE</v-list-item-title></v-list-item-content>
                    </v-list-item>
                    <v-list-item :key="4" :to="'/manage'" v-on:click.native="setMode('Manage')">
                        <v-list-item-icon><v-icon color="black">account_tree</v-icon></v-list-item-icon>
                        <v-list-item-content><v-list-item-title class="boldtext" style="color:black;">MANAGE</v-list-item-title></v-list-item-content>
                    </v-list-item>
                    <v-list-item :key="5" :to="'/settings'" v-on:click.native="setMode('Settings')">
                        <v-list-item-icon><v-icon color="black">settings</v-icon></v-list-item-icon>
                        <v-list-item-content><v-list-item-title class="boldtext" style="color:black;">SETTINGS</v-list-item-title></v-list-item-content>
                    </v-list-item>
                    <v-list-item :key="6" v-on:click.native="logout">
                        <v-list-item-icon><v-icon color="black">phonelink_erase</v-icon></v-list-item-icon>
                        <v-list-item-content><v-list-item-title class="boldtext" style="color:black;">LOGOUT</v-list-item-title></v-list-item-content>
                    </v-list-item>
                </v-list-item-group>
            </v-list>
        </v-navigation-drawer>

        <v-navigation-drawer app v-click-outside="handleClickOutside" v-model="mapvisible" width="400" height="400" absolute temporary class="primary">
            <v-content>
                <Map />
            </v-content>
        </v-navigation-drawer>

        <v-navigation-drawer app v-click-outside="handleClickOutside" v-model="addtagvisible" width="400" :height="navdrawerheight" absolute temporary color="alertlevel">
            <v-content>
                <AddTag />
            </v-content>
        </v-navigation-drawer>

        <v-toolbar v-if="showHamburger" color="#FFA500" class=" pb-0" dark>
            <v-btn @click="setnavbar()" icon color="#FFA500" class="py-3">
                <v-icon color="black">menu</v-icon>
            </v-btn>
        </v-toolbar>

        <v-toolbar v-if="CheckedButNotAuthenticated" color="#FFA500">

            <v-spacer></v-spacer>

            <v-btn icon color="black" style="width: 130px;" to="/login">
                <v-icon>lock_open</v-icon>
                <span>Login</span>
            </v-btn>

            <v-btn icon color="black" style="width: 130px;" to="/register">
                <v-icon>how_to_reg</v-icon>
                <span>Register</span>
            </v-btn>
        </v-toolbar>

    </span>
</template>

<script>

    import Map from '@/components/Map';
    import AddTag from '@/components/AddTag';
    import ClickOutside from 'vue-click-outside';

export default {
        name: 'AppNavigation',
        directives: {
            ClickOutside,
        },
        components: {
            Map,
            AddTag
        },
        mounted:function(){
            //alert("mounted navbar");
            this.$store.state.heading = "";
            this.$store.state.navpage = this;
        },
        data() {
            return {
                appTitle: 'MissionAlert',
                drawermain: false,
                panoimage: "https://firebasestorage.googleapis.com/v0/b/missionshare-2f93c.appspot.com/o/sphericalimage.jpg?alt=media&token=e268a03d-26de-4cdd-aeeb-512202ea9ab9",
            };
        },
        computed: {
            greencount() {
                return "" + this.$store.state.greenalertcount + " green";
            },
            ambercount() {
                return "" + this.$store.state.amberalertcount + " amber";
            },
            redcount() {
                return "" + this.$store.state.redalertcount + " red";
            },
            greenalertsexist() {
                if (this.$store.state.greenalertcount > 0)
                    return true;
                else
                    return false;
            },
            amberalertsexist() {
                if (this.$store.state.amberalertcount > 0)
                    return true;
                else
                    return false;
            },
            redalertsexist() {
                if (this.$store.state.redalertcount > 0)
                    return true;
                else
                    return false;
            },
            alertlevel() {
                return this.$store.state.alertlevel;
            },
            navdrawerheight() {
                return this.$store.state.navdrawerheight;
            },
            CheckedButNotAuthenticated() {
                if (this.$store.getters.isAuthenticated === "false") {
                    //alert("CBNA");
                    return true;
                }
                return false;
            },
            showHamburger() {
                window.vuethis = this;
                this.$root.$confirm = window.rootconfirm;
                if (this.$store.state.heading != "") {
                    return false;
                }
                if (this.$store.getters.isAuthenticated === "true") {
                    return true;
                }
                return false;
            },
            isAuthCapture() {
                if (!(this.$store.getters.isAuthenticated === "true")) return false;
                if (this.$store.state.heading === "Capture") return true;
                else return false;
            },
            mapvisible() {
                return this.$store.state.mapvisible;
            },
            addtagvisible() {
                return this.$store.state.addtagvisible;
            }
        },
        methods: {
            setnavbar(){
                this.drawermain= !this.drawermain;
                this.$store.state.chipcount++;
            },
            logout() {
                this.$store.state.heading = "";
                this.$store.dispatch('userSignOut');
                this.drawermain = false;
            },
            setMode(val) {  
                this.$store.state.isAuthenticated = "true";
                this.$store.state.heading = val;
                if (val == "ChooseSurvey") {
                    this.$store.state.undermanagement = false;
                    this.$store.state.heading = "Choose a survey to explore...";
                    this.$store.state.deletesurveys = false;
                }
                else {
                    this.$store.state.deletesurveys = true;
                    if (val == "ChooseShare") {
                        this.$store.state.undermanagement = false;
                        this.$store.state.heading = "Share";
                        this.$store.state.onlymyshares = true;     
                        this.$router.push({ path: 'chooseshare' })
                    }
                    else {
                        this.$store.state.undermanagement = true;
                        this.$store.state.onlymyshares = false;
                    }
                }
                this.$store.state.updatecount++;
                this.drawermain=false;        
            },
            handleClickOutside() {
                if (this.$store.state.mapbutton) {
                    if (!this.$store.state.mapvisible)
                        this.switchMap();
                }
                this.$store.state.mapbutton = false;

                if (this.$store.state.addtagbutton) {
                    if (!this.addtagvisible)
                        this.switchAddTag();
                }
                this.$store.state.addtagbutton = false;
            },
            switchMap() {
                this.$store.state.mapvisible = !this.$store.state.mapvisible;
            },
            switchAddTag() {
                this.$store.state.addtagvisible = !this.$store.state.addtagvisible;
            }
        }
};
</script>

<style scoped>
a {
    color: white;
    text-decoration: none;
}

.boldtext {
    font-weight: bold;
}

</style>
